
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface SearchFilterProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
}

export function SearchFilter({ searchQuery, onSearchChange }: SearchFilterProps) {
  return (
    <div>
      <Label className="text-foreground">Search</Label>
      <div className="flex gap-2">
        <Input
          placeholder="Search jobs..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="bg-background border-border text-foreground placeholder:text-muted-foreground rounded-sm"
        />
      </div>
    </div>
  );
}
